// @flow
import {ROUTE} from 'app/constants/route';
import {PrivateRoute} from 'app/routes/private-route';
import {FullLoader} from 'modules/common/components/FullLoader';
import {NewEmailExpiredPage} from 'modules/common/components/NewEmailExpiredPage';
import {OutdatedBrowser} from 'modules/common/components/OutdatedBrowser';
import {TestPage} from 'modules/common/components/TestPage';
import React from 'react';
import loadable from 'react-loadable';
import {Route, Switch} from 'react-router-dom';

const CommonRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "common" */
            'modules/common/routes'
        ),
    loading: FullLoader,
});

const AuthRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "auth" */
            'modules/auth/routes'
        ),
    loading: FullLoader,
});

const TrainingModulesRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "trainingModules" */
            'modules/trainingModules/routes'
        ),
    loading: FullLoader,
});

const SettingsRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "user" */
            'modules/settings/routes'
        ),
    loading: FullLoader,
});

const DashboardRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "user" */
            'modules/dashboard/routes'
        ),
    loading: FullLoader,
});

const LicenseListRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "user" */
            'modules/license/routes'
        ),
    loading: FullLoader,
});

const userRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "user" */
            'modules/user/routes'
        ),
    loading: FullLoader,
});

const StyleguideRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "styleguide" */
            'modules/styleguide/routes'
        ),
    loading: FullLoader,
});

const DocumentPageRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "styleguide" */
            'modules/documents/routes'
        ),
    loading: FullLoader,
});

const NoMatchRoutes = loadable({
    loader: () =>
        import(
            /* webpackChunkName: "no-match" */
            'app/routes/no-match-route'
        ),
    loading: FullLoader,
});

/**
 * Корневой роутинг приложения
 * @returns React-компонент
 */
const AppRoutes = () => {
    const isOutdatedBrowser = 0 < navigator.userAgent.search(/MSIE/u) || 0 < navigator.userAgent.search(/NET CLR /u);
    return isOutdatedBrowser ? (
        <OutdatedBrowser />
    ) : (
        <Switch>
            <Route component={CommonRoutes} exact path="/" />
            <Route component={DocumentPageRoutes} exact path={`/${ROUTE.DOCUMENTS}`} />
            <Route component={StyleguideRoutes} exact path={`/${ROUTE.STYLE_GUIDE}`} />
            <Route component={AuthRoutes} path={`/${ROUTE.AUTH}`} />
            <Route component={SettingsRoutes} path={`/${ROUTE.SETTINGS}`} />
            <Route component={TrainingModulesRoutes} path={`/${ROUTE.TRAINING_MODULE}`} />
            <Route component={DashboardRoutes} path={`/${ROUTE.DASHBOARD}`} />
            <Route component={LicenseListRoutes} path={`/${ROUTE.LICENSE}`} />
            <Route component={userRoutes} path={`/${ROUTE.USERS}`} />
            <Route component={TestPage} path="/test" />
            <Route component={NewEmailExpiredPage} path="/email-verification-failed" />
            <PrivateRoute component={NoMatchRoutes} />
        </Switch>
    );
};

export default AppRoutes;
